import { Link } from 'react-router-dom'
import AdminLayout from '../../components/admin/AdminLayout'
import './Admin.css'

export default function AdminDashboard() {
  return (
    <AdminLayout>
      <div className="admin-dashboard">
        <h1>관리자 대시보드</h1>
        <div className="admin-grid">
          <Link to="/admin/notices" className="admin-card">
            <h2>📢 공지사항 관리</h2>
            <p>공지사항을 작성하고 관리하세요</p>
          </Link>
          <Link to="/admin/semesters" className="admin-card">
            <h2>📅 학년도/계절 관리</h2>
            <p>학년도와 계절을 등록하고 관리하세요</p>
          </Link>
          <Link to="/admin/courses/create" className="admin-card">
            <h2>➕ 강의 등록</h2>
            <p>새로운 강의를 등록하세요</p>
          </Link>
          <Link to="/admin/courses/list" className="admin-card">
            <h2>📚 강의 목록</h2>
            <p>등록된 강의를 확인하고 수정하세요</p>
          </Link>
          <Link to="/admin/enrollments" className="admin-card">
            <h2>✍️ 수강신청 관리</h2>
            <p>전체 수강신청 내역을 확인하세요</p>
          </Link>
          <Link to="/admin/grades" className="admin-card">
            <h2>📝 성적 관리</h2>
            <p>성적을 입력하고 관리하세요</p>
          </Link>
          <Link to="/admin/completions" className="admin-card">
            <h2>✅ 이수 관리</h2>
            <p>이수 완료된 학생들의 성적과 학점을 확인하세요</p>
          </Link>
          <Link to="/admin/users" className="admin-card">
            <h2>👥 회원 관리</h2>
            <p>가입한 회원 정보와 이수내역을 확인하세요</p>
          </Link>
          <Link to="/certificate" className="admin-card">
            <h2>📄 이수증명서</h2>
            <p>학생의 이수증명서를 발급하세요</p>
          </Link>
          <Link to="/admin/legacy-completions" className="admin-card">
            <h2>📜 이전 이수 내역</h2>
            <p>이전 이수 내역을 관리하세요</p>
          </Link>
          <Link to="/admin/statistics" className="admin-card">
            <h2>📈 통계</h2>
            <p>수강신청 통계를 확인하세요</p>
          </Link>
        </div>
      </div>
    </AdminLayout>
  )
}

